import { render } from "./CardManage.vue?vue&type=template&id=481261ac&scoped=true"
import script from "./CardManage.vue?vue&type=script&lang=js"
export * from "./CardManage.vue?vue&type=script&lang=js"

import "./CardManage.vue?vue&type=style&index=0&id=481261ac&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-481261ac"]])

export default __exports__